export default class EventGameFixtureNumberModel {
  public min: number = 0;
  public max: number = 0;
}
